import { render, staticRenderFns } from "./OpdrachtenHeader.vue?vue&type=template&id=60433ac0&scoped=true&"
import script from "./OpdrachtenHeader.vue?vue&type=script&lang=js&"
export * from "./OpdrachtenHeader.vue?vue&type=script&lang=js&"
import style0 from "./OpdrachtenHeader.vue?vue&type=style&index=0&id=60433ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60433ac0",
  null
  
)

export default component.exports